import { Switch, Tooltip, Typography } from '@material-tailwind/react'
import React from 'react'
import { PiInfoLight } from 'react-icons/pi'
import { useTranslation } from 'react-i18next'
import { colors } from '@material-tailwind/react/types/generic'
import { useDarkMode } from '../contexts/DarkModeContext'

interface AgamiSpot {
  type: number
}

interface AgamiVisibilitySelectorProps {
  isPublic: boolean
  setIsPublic: (isPublic: boolean) => void
  formData: AgamiSpot
}

const AgamiVisibilitySelector: React.FC<AgamiVisibilitySelectorProps> = ({
  isPublic,
  setIsPublic,
  formData,
}) => {
  const { t } = useTranslation()
  const { darkMode } = useDarkMode()
  return (
    <div className="flex flex-col gap-2 items-start bg-white dark:bg-primary rounded-lg p-4 shadow-sm">
      <div className="flex gap-1 justify-center items-center">
        <Typography className="font-bold text-primary text-lg font-barlow">
          {t('upload.visibility.title')}
        </Typography>
        <Tooltip
          content={
            <div className="w-[300px]">
              <Typography variant="small" className="font-bold">
                {t('upload.visibility.description')}
              </Typography>
            </div>
          }
          placement="right"
          interactive
        >
          <span>
            <PiInfoLight className="text-primary dark:text-base-gray-400" />
          </span>
        </Tooltip>
      </div>

      <div data-testid="agami-visibility-switch">
        <Switch
          id="public_spot"
          color={(darkMode ? 'accent' : 'primary') as colors}
          label={t('upload.visibility.makePublic')}
          checked={isPublic}
          onChange={(e) => setIsPublic(e.currentTarget.checked)}
          disabled={formData.type === 2}
          labelProps={{
            className: 'text-gray-600 dark:!text-gray-200',
          }}
        />
      </div>
    </div>
  )
}

export default AgamiVisibilitySelector
